import { getLinkData } from '@/core/utils';
import { CarouselRhtvFragment, AcfMediaFragment } from "@graphqlTypes";

type Channel = CarouselRhtvFragment["channels"][number];
export type ChannelData = {
  title: string;
  excerpt: string | null;
  uri?: string;
  linkTarget?: string;
  labelOverride?: string;
  pillLabel?: string;
  thumbnail: AcfMediaFragment;
  previewVideo: string | null;
}

export const getChannelData = (channel: Channel): ChannelData | undefined => {
  switch (channel.type[0]) {
    case "channel": {
      if (!channel?.channel) return undefined;
      const { channel: { nodes }, labelOverride, pillLabel } = channel;
      if (!nodes || nodes.length === 0 || nodes[0].__typename !== "RhtvChannel") return undefined;
      const channelData = nodes[0];
      const { rhtvChannelContent: { previewVideo, thumbnail, excerpt }, title, uri } = channelData;
      return {
        title: title || '',
        excerpt,
        previewVideo,
        pillLabel,
        thumbnail,
        uri,
        labelOverride
      };
    }
    case "manual": {
      const { manualSlide, labelOverride, pillLabel } = channel;
      const { headline, link, excerpt, videoUrl, image, videoThumbnail } = manualSlide;
      const linkData = getLinkData(link, true);
      const thumbnail = videoThumbnail || image;
      return {
        title: headline || '',
        excerpt,
        previewVideo: videoUrl,
        pillLabel,
        labelOverride,
        thumbnail,
        linkTarget: linkData.target,
        uri: linkData.url
      };
    }
    default: 
      return undefined;
  }
}